import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiSettings } from '@common/constants';

@Injectable({
  providedIn: 'root' // No need for a module
})
export class BackendService {
  private provisionApiUrl = apiSettings.baseApiUrl;
  private ecommerceApiUrl = apiSettings.ecommerceApiUrl;
  private provisionApiVersion = apiSettings.baseApiVersion;
  private ecommerceApiVersion = apiSettings.ecommerceApiVersion;

  constructor(private http: HttpClient) {}

  get<T>(endpoint: string, params?: any, fromEcommerceApi?: boolean | false): Observable<T> {
    let apiUrl = fromEcommerceApi === true ? this.ecommerceApiUrl : this.provisionApiUrl;
    let apiVersion = fromEcommerceApi === true ? this.ecommerceApiVersion : this.provisionApiVersion;
    
    let headers = new HttpHeaders().set('content-type', 'application/json');    
    return this.http.get<T>(`${apiUrl}/${apiVersion}/${endpoint}`, { params, headers });
  }

  post<T>(endpoint: string, body: any, fromEcommerceApi?: boolean | false): Observable<T> {
    let apiUrl = fromEcommerceApi === true ? this.ecommerceApiUrl : this.provisionApiUrl;
    let apiVersion = fromEcommerceApi === true ? this.ecommerceApiVersion : this.provisionApiVersion;
    
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<T>(`${apiUrl}/${apiVersion}/${endpoint}`, body, { headers });
  }

  put<T>(endpoint: string, body: any, fromEcommerceApi?: boolean | false): Observable<T> {
    let apiUrl = fromEcommerceApi === true ? this.ecommerceApiUrl : this.provisionApiUrl;
    let apiVersion = fromEcommerceApi === true ? this.ecommerceApiVersion : this.provisionApiVersion;
    
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.put<T>(`${apiUrl}/${apiVersion}/${endpoint}`, body, {headers});
  }

  patch<T>(endpoint: string, body: any, fromEcommerceApi?: boolean | false): Observable<T> {
    let apiUrl = fromEcommerceApi === true ? this.ecommerceApiUrl : this.provisionApiUrl;
    let apiVersion = fromEcommerceApi === true ? this.ecommerceApiVersion : this.provisionApiVersion;
    
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.patch<T>(`${apiUrl}/${apiVersion}/${endpoint}`, body, {headers});
  }

  delete<T>(endpoint: string, fromEcommerceApi?: boolean | false): Observable<T> {
    let apiUrl = fromEcommerceApi === true ? this.ecommerceApiUrl : this.provisionApiUrl;
    let apiVersion = fromEcommerceApi === true ? this.ecommerceApiVersion : this.provisionApiVersion;
    
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.delete<T>(`${apiUrl}/${apiVersion}/${endpoint}`, {headers});
  }
}